import { PureAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';
import { createContext, useContext } from 'react';

import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';
import { TAbilityProviderProps } from '@/shared/features/ability/context/ability-context.types';
import { useUserAbility } from '@/shared/features/ability/hooks/use-user-ability/use-user-ability';
import { TAppAbility } from '@/shared/features/ability/hooks/use-user-ability/use-user-ability.types';

const defaultAbility = new PureAbility([]) as TAppAbility;

export const AbilityContext = createContext<TAppAbility>(defaultAbility);
export const Can = createContextualCan(AbilityContext.Consumer);

export const AbilityProvider = ({ children }: TAbilityProviderProps) => {
  const { ability, isLoading } = useUserAbility();

  if (isLoading) {
    return <FullscreenLoader />;
  }

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
};

export const useAbility = () => {
  return useContext(AbilityContext);
};
